import React, { useContext, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import useHistory from "routing/useHistory";
import useLocation from "routing/useLocation";
import useRightSidebar from "hooks/useRightSidebar";
import { ScratchpadContext } from "contexts/ScratchpadProvider";
import { Button } from "components/bootstrap";
import { hoverIndicatorStyles } from "components/common/NavItemStateIndicator";
import { manager } from "./tourManagerInstance";
import useVerascendTourConfig from "./useVerascendTourConfig";
const NavButton = styled(Button)(
  ({ theme, $smallScreen }) => css`
    /* Per Product's 2026-11-03 feedback: the pill was sized to this nav
       item's own full-row min-height (NAV_ITEM_HEIGHT, 50px), which made the
       border-radius curvature — and the surrounding whitespace it implies —
       much larger than the neighboring 'DEV' badge's (a compact 20px-tall
       Mantine Badge). Vertical centering doesn't depend on this element's own
       height, though: this button, like the badge, is a child of the single
       InactiveNavItem ('dev-badge-wrap') wrapper shared by every item in this
       row — confirmed live that wrapper renders as an anchor with
       inline-flex display and centered alignment, which centers both
       regardless of their height. So matching the badge's own compact box
       (padding, height) instead of the full row height gives the same tight
       pill proportions without losing that centering. */
    padding: 0 10px;
    height: 20px;
    margin-left: 8px;
    background: none;
    /* Per Product's 2026-11-03 request: a pill-shaped outline in the same
       color as the text, transparent inside, with the same corner radius as
       the neighboring "DEV" badge — confirmed live that badge's own
       border-radius computes to 1000px (a true pill/stadium shape, not a
       fixed px value), so this matches that exactly rather than guessing a
       smaller radius that would look subtly squarer at this button's width. */
    border: 1px solid currentColor;
    border-radius: 1000px;
    display: inline-flex;
    align-items: center;
    color: ${theme.colors.text.primary};
    font-family: ${theme.fonts.family.navigation};
    font-size: ${theme.fonts.size.navigation};

    &:hover,
    &:focus-visible {
      ${hoverIndicatorStyles(theme)}
      background: transparent;
      color: ${theme.colors.variant.darker.default};
    }

    ${$smallScreen && css`
      &.small-scrn-badge {
        float: right;
      }
    `}
  `
);
export default function TourRestartNavItem({ smallScreen = false }) {
  const { enabled: tourEnabled } = useVerascendTourConfig();
  const [state, setState] = useState(() => manager.getState());
  const location = useLocation();
  const history = useHistory();
  const { closeSidebar } = useRightSidebar();
  const { setScratchpadVisibility } = useContext(ScratchpadContext);
  useEffect(() => manager.subscribe(setState), []);
  if (!tourEnabled || state.active) return null;
  const startTour = () => {
    closeSidebar();
    setScratchpadVisibility(false);
    if (!location.pathname.includes("/welcome")) {
      history.push("/welcome");
    }
    manager.restart();
  };
  return /* @__PURE__ */ React.createElement(
    NavButton,
    {
      bsStyle: "link",
      type: "button",
      onClick: startTour,
      title: "Restart product tour",
      className: smallScreen ? "small-scrn-badge" : "",
      $smallScreen: smallScreen
    },
    "Product Tour"
  );
}
